import { render, staticRenderFns } from "./PromotionDiscountOnTopPaymentGroup.vue?vue&type=template&id=68fadc46&scoped=true&"
import script from "./PromotionDiscountOnTopPaymentGroup.vue?vue&type=script&lang=js&"
export * from "./PromotionDiscountOnTopPaymentGroup.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDiscountOnTopPaymentGroup.vue?vue&type=style&index=0&id=68fadc46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fadc46",
  null
  
)

export default component.exports